import React from 'react';
import { TextField, Box } from '@mui/material';

const SearchBar = ({ onSearch }) => {
  const handleSearchChange = (event) => {
    onSearch(event.target.value);
  };

  return (
    <Box my={2}>
      <TextField
        fullWidth
        variant="outlined"
        label="Search Conversations"
        onChange={handleSearchChange}
      />
    </Box>
  );
};

export default SearchBar;
